import { service } from 'Services/api/api.service';
import { store } from 'Store';
import { taxSelectedSelector } from 'Store/modules/tax/selectors';
import { TAX_YEAR } from 'Config';
import { RecordsServiceType } from './types';

const BASE_ENDPOINT_URL = '/tax/records';

const getRecordId = (): string | undefined => {
  const { recordId } = taxSelectedSelector(store.getState()) ?? {};
  return recordId;
};

const RecordsService: RecordsServiceType = {
  getUserData: () => service.get(`${BASE_ENDPOINT_URL}/${getRecordId()}/data`),
  getRecords: params => service.get(`${BASE_ENDPOINT_URL}`, { params }),
  getResultData: () => service.get(`${BASE_ENDPOINT_URL}/${getRecordId()}/result`),
  setUserData: ({ stage, data, next }) =>
    service.patch(`${BASE_ENDPOINT_URL}/${getRecordId()}`, { stage, data, next }),
  resetUsers: () => service.post(`${BASE_ENDPOINT_URL}/${getRecordId()}/reset`),
  restartUsers: ({ stage }) =>
    service.post(`${BASE_ENDPOINT_URL}/${getRecordId()}/restart`, { stage }),
  getFiledInfo: () => service.get(`${BASE_ENDPOINT_URL}/${getRecordId()}/submitInfo`),
  setFiledInfo: dataInfo =>
    service.patch(`${BASE_ENDPOINT_URL}/${getRecordId()}`, { submitInfo: dataInfo }),
  setSubmit: () => service.post(`${BASE_ENDPOINT_URL}/${getRecordId()}/submit`),
  saveInstantRefund: () => service.post('/instant-refund'),
  getInstantRefundRequest: () =>
    service.get('/instant-refund', {
      params: {
        taxYear: TAX_YEAR,
      },
    }),
  getFlowFeatureFlagIsActive: () =>
    service.get('/records-archive/flow', {
      params: {
        taxYear: TAX_YEAR,
      },
    }),
  getRecordArchive: () =>
    service.get('/records-archive', {
      params: {
        taxYear: TAX_YEAR,
      },
    }),
  saveClabeAndSubmit: ({ clabe, recordId }) =>
    service.patch(`/records-archive/${recordId}`, {
      clabe,
    }),
  getRecordArchiveClabe: () =>
    service.get('/records-archive/clabe', {
      params: {
        taxYear: TAX_YEAR,
      },
    }),
  confirmDeclaration: ({ confirm }) =>
    service.patch(`${BASE_ENDPOINT_URL}/${getRecordId()}/validation`, { confirm: !!confirm }),
};

export default RecordsService;
